import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data); 
export const getProcessMonthlySalary = (data) => Ajax.post('account/getProcessMonthlySalary',data); 
export const freezeSalary = (data) => Ajax.post('account/freezeSalary',data); 
